const translations = {
  DE: {
    paymentPart: "Zahlteil",
    account: "Konto / Zahlbar an",
    reference: "Referenz",
    additionalInformation: "Zusätzliche Informationen",
    currency: "Währung",
    amount: "Betrag",
    receipt: "Empfangsschein",
    acceptancePoint: "Annahmestelle",
    separate: "Vor der Einzahlung abzutrennen",
    payableBy: "Zahlbar durch",
    payableByName: "Zahlbar durch (Name/Adresse)",
    inFavourOf: "Zugunsten"
  },
  EN: {
    paymentPart: "Payment part",
    account: "Account / Payable to",
    reference: "Reference",
    additionalInformation: "Additional information",
    currency: "Currency",
    amount: "Amount",
    receipt: "Receipt",
    acceptancePoint: "Acceptance point",
    separate: "Separate before paying in",
    payableBy: "Payable by",
    payableByName: "Payable by (name/address)",
    inFavourOf: "In favour of"
  },
  IT: {
    paymentPart: "Sezione pagamento",
    account: "Conto / Pagabile a",
    reference: "Riferimento",
    additionalInformation: "Informazioni supplementari",
    currency: "Valuta",
    amount: "Importo",
    receipt: "Ricevuta",
    acceptancePoint: "Punto di accettazione",
    separate: "Da staccare prima del versamento",
    payableBy: "Pagabile da",
    payableByName: "Pagabile da (nome/indirizzo)",
    inFavourOf: "A favore di"
  },
  FR: {
    paymentPart: "Section paiement",
    account: "Compte / Payable à",
    reference: "Référence",
    additionalInformation: "Informations supplémentaires",
    currency: "Monnaie",
    amount: "Montant",
    receipt: "Récépissé",
    acceptancePoint: "Point de dépôt",
    separate: "A détacher avant le versement",
    payableBy: "Payable par",
    payableByName: "Payable par (nom/adresse)",
    inFavourOf: "En faveur de"
  }
};

export default translations;